"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectedFeedSelector = exports.isFeedAdministratorById = exports.hasFeedByIdSelector = exports.getUnicastFeedsEntities = exports.getTypingUsers = exports.getSubscriptionFeeds = exports.getSelectedFeed = exports.getRoomFeedsEntities = exports.getPendingSubscriptions = exports.getMulticastFeedsEntities = exports.getHasUnreadFeeds = exports.getFeedsLoaded = exports.getFeedsError = exports.getFeedsAcceptedUnicastIds = exports.getFeedsAcceptedMulticastIds = exports.getFeedsAccepted = exports.getFeedIdByUserIdSelector = exports.feedTypingSelector = exports.feedLiteByIdSelector = exports.feedInputSelector = exports.feedInputByIdSelector = exports.feedByIdSelector = exports._unreadFeeds = void 0;
var _reselect = require("reselect");
var _selectors = require("../rooms/selectors");
var _selectors2 = require("../entities/selectors");
var _constants = require("./constants");
var _selectors3 = require("../session/selectors");
var _selectors4 = require("../members/selectors");
var _selectors5 = require("../users/selectors");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _feedsSelector = state => state.feeds.items;
var _getFeedParameter = (_, _feed) => _feed;
var _getUserParameter = (_, _feed) => _feed;
var feedTypingSelector = state => state.feeds.typing;
exports.feedTypingSelector = feedTypingSelector;
var feedInputSelector = state => state.feeds.inputByFeed;
exports.feedInputSelector = feedInputSelector;
var feedsEntitySelector = state => (0, _selectors2.entitiesSelector)(state).feeds;
var userEntitySelector = state => (0, _selectors2.entitiesSelector)(state).users;
var selectedFeedSelector = state => state.feeds.selected;
exports.selectedFeedSelector = selectedFeedSelector;
var anchorsSelector = state => (0, _selectors2.entitiesSelector)(state).anchors;
var _anchorsSelector = state => state.feeds.anchors;
var acknowledgementsSelector = state => state.feeds.acknowledgements;
var userAcknowledgementsSelector = state => state.feeds.userAcknowledgements;
var invitationsEntitySelector = state => (0, _selectors2.entitiesSelector)(state).invitations;
var sortFeedsByDate = feeds => feeds.sort((a, b) => new Date(b.lastItemPostedAt || b.createdAt) - new Date(a.lastItemPostedAt || a.createdAt));
var getFeedIdByUserIdSelector = exports.getFeedIdByUserIdSelector = (0, _reselect.createSelector)([_getUserParameter, anchorsSelector], (_user, anchors) => {
  var match = Object.values(anchors).filter(x => x.target === _user);
  if (match && match.length) {
    var _match$;
    return (_match$ = match[0]) === null || _match$ === void 0 ? void 0 : _match$.feed;
  }
  return undefined;
});
var hasFeedByIdSelector = _feed => state => _feedsSelector(state).includes(_feed);
exports.hasFeedByIdSelector = hasFeedByIdSelector;
var isFeedAdministratorById = (_feed, _user) => state => {
  var _feed$_administrators;
  var feed = feedByIdSelector(state, _feed);
  return !!feed && ((_feed$_administrators = feed._administrators) === null || _feed$_administrators === void 0 ? void 0 : _feed$_administrators.includes(_user));
};
exports.isFeedAdministratorById = isFeedAdministratorById;
var feedLiteByIdSelector = _feed => (0, _reselect.createSelector)([feedsEntitySelector, _selectors5.userEntitiesSelector], (feedEntities, userEntities) => {
  var feed = feedEntities[_feed] || {};
  var user = userEntities[feed === null || feed === void 0 ? void 0 : feed._user];
  return {
    createdAt: feed.createdAt,
    cast: feed.cast,
    name: feed.name,
    user
  };
});
exports.feedLiteByIdSelector = feedLiteByIdSelector;
var feedInputByIdSelector = _feed => state => {
  var _feedInputSelector;
  return ((_feedInputSelector = feedInputSelector(state)) === null || _feedInputSelector === void 0 ? void 0 : _feedInputSelector[_feed]) || {};
};
exports.feedInputByIdSelector = feedInputByIdSelector;
var getFeedsLoaded = state => state.feeds.loaded;
exports.getFeedsLoaded = getFeedsLoaded;
var getFeedsError = state => state.feeds.error;
exports.getFeedsError = getFeedsError;
var getMulticastFeedsEntities = exports.getMulticastFeedsEntities = (0, _reselect.createSelector)([_feedsSelector, feedsEntitySelector, acknowledgementsSelector, userAcknowledgementsSelector, _selectors3.getUserId, _selectors5.userEntitiesSelector], (_feeds, feedEntities, acknowledgements, userAcknowledgements, _currentUser, userEntities) => {
  return _feeds.reduce((feedAccumulator, _feed) => {
    var _feed$lastItemPosted;
    var feed = feedEntities[_feed];
    if (!feed || feed.cast !== _constants.FEED_TYPE.MULTICAST) {
      return feedAccumulator;
    }
    if (feed !== null && feed !== void 0 && (_feed$lastItemPosted = feed.lastItemPosted) !== null && _feed$lastItemPosted !== void 0 && _feed$lastItemPosted._user) {
      var writter = userEntities[feed.lastItemPosted._user];
      if (writter) {
        feed.lastItemPosted = _objectSpread(_objectSpread({}, feed.lastItemPosted), {}, {
          firstname: writter === null || writter === void 0 ? void 0 : writter.firstname,
          lastname: writter === null || writter === void 0 ? void 0 : writter.lastname,
          you: feed.lastItemPosted._user === _currentUser
        });
      }
    }
    return feedAccumulator.concat(_objectSpread(_objectSpread({}, feed), {}, {
      isOwned: feed._user === _currentUser
    }));
  }, []);
});
var getPendingSubscriptions = exports.getPendingSubscriptions = (0, _reselect.createSelector)([invitationsEntitySelector, _selectors4.pendingMembersSelector, userEntitySelector, feedsEntitySelector], (invitationsEntities, invitationsPending, userEntities, feedEntities) => {
  return invitationsPending.reduce((result, id) => {
    var _invitationsEntities$, _invitationsEntities$2;
    if (invitationsEntities !== null && invitationsEntities !== void 0 && invitationsEntities[id] && invitationsEntities !== null && invitationsEntities !== void 0 && (_invitationsEntities$ = invitationsEntities[id]) !== null && _invitationsEntities$ !== void 0 && _invitationsEntities$._feed && userEntities !== null && userEntities !== void 0 && userEntities[invitationsEntities === null || invitationsEntities === void 0 || (_invitationsEntities$2 = invitationsEntities[id]) === null || _invitationsEntities$2 === void 0 ? void 0 : _invitationsEntities$2._initiator]) {
      result.push(_objectSpread(_objectSpread({}, invitationsEntities[id]), {}, {
        feed: feedEntities[invitationsEntities[id]._feed],
        initiator: userEntities[invitationsEntities[id]._initiator]
      }));
    }
    return result;
  }, []);
});
var getUnicastFeedsEntities = exports.getUnicastFeedsEntities = (0, _reselect.createSelector)([feedsEntitySelector, userEntitySelector, anchorsSelector, _anchorsSelector, _selectors3.getUserId], (feedEntities, userEntities, anchors, _anchors, _currentUser) => {
  return _anchors.map(_anchor => {
    var anchor = anchors === null || anchors === void 0 ? void 0 : anchors[_anchor];
    if (!anchor) return null;
    var user = anchor._target === _currentUser ? userEntities[anchor._initiator] : userEntities[anchor._target];
    var unicastFeed = feedEntities[anchors[_anchor]._feed];
    if (unicastFeed !== null && unicastFeed !== void 0 && unicastFeed.lastItemPosted) {
      unicastFeed.lastItemPosted.you = unicastFeed.lastItemPosted._user === _currentUser;
    }
    if (unicastFeed && user) {
      return _objectSpread(_objectSpread({}, unicastFeed), {}, {
        isOwned: anchor._target !== _currentUser,
        _subscription: null,
        _anchor,
        user
      });
    }
    return null;
  }).filter(anchorEntity => anchorEntity !== null);
});
var getRoomFeedsEntities = exports.getRoomFeedsEntities = (0, _reselect.createSelector)([feedsEntitySelector], feedEntities => Object.values(feedEntities).filter(feed => !!(feed !== null && feed !== void 0 && feed._room)));
var feedByIdSelector = exports.feedByIdSelector = (0, _reselect.createSelector)([_getFeedParameter, getUnicastFeedsEntities, getMulticastFeedsEntities, getRoomFeedsEntities], (_feed, unicastFeeds, multicastFeeds, roomFeeds) => {
  var unicastFeed = unicastFeeds.find(_ref => {
    var {
      id
    } = _ref;
    return id === _feed;
  });
  if (unicastFeed) return unicastFeed;
  var multicastFeed = multicastFeeds.find(_ref2 => {
    var {
      id
    } = _ref2;
    return id === _feed;
  });
  if (multicastFeed) return multicastFeed;
  return roomFeeds.find(_ref3 => {
    var {
      id
    } = _ref3;
    return id === _feed;
  });
});
var getFeedsAcceptedUnicastIds = exports.getFeedsAcceptedUnicastIds = (0, _reselect.createSelector)([getUnicastFeedsEntities, acknowledgementsSelector, userAcknowledgementsSelector], (unicastFeedsEntities, acknowledgements, userAcknowledgements) => {
  var _sortFeedsByDate;
  return (_sortFeedsByDate = sortFeedsByDate(unicastFeedsEntities, userAcknowledgements, acknowledgements)) === null || _sortFeedsByDate === void 0 ? void 0 : _sortFeedsByDate.map(feed => feed.id);
});
var getFeedsAcceptedMulticastIds = exports.getFeedsAcceptedMulticastIds = (0, _reselect.createSelector)([getMulticastFeedsEntities, acknowledgementsSelector, userAcknowledgementsSelector], (multicastFeedsEntities, acknowledgements, userAcknowledgements) => {
  var _sortFeedsByDate2;
  return (_sortFeedsByDate2 = sortFeedsByDate(multicastFeedsEntities, userAcknowledgements, acknowledgements)) === null || _sortFeedsByDate2 === void 0 ? void 0 : _sortFeedsByDate2.map(feed => feed.id);
});
var getFeedsAccepted = exports.getFeedsAccepted = (0, _reselect.createSelector)([getUnicastFeedsEntities, getMulticastFeedsEntities, acknowledgementsSelector, userAcknowledgementsSelector], (unicastFeedsEntities, multicastFeedsEntities, acknowledgements, userAcknowledgements) => sortFeedsByDate([...unicastFeedsEntities, ...multicastFeedsEntities], userAcknowledgements, acknowledgements));
var getHasUnreadFeeds = exports.getHasUnreadFeeds = (0, _reselect.createSelector)([getFeedsAccepted], feedEntities => !!feedEntities.find(_ref4 => {
  var {
    unreadCount
  } = _ref4;
  return unreadCount > 0;
}));
var _unreadFeeds = exports._unreadFeeds = (0, _reselect.createSelector)([getFeedsAccepted], feedEntities => {
  return feedEntities.reduce((acc, feed) => {
    if (feed.unreadCount) acc.push(feed.id);
    return acc;
  }, []);
});
var getSelectedFeed = exports.getSelectedFeed = (0, _reselect.createSelector)([selectedFeedSelector, feedsEntitySelector, userEntitySelector, anchorsSelector, _anchorsSelector, _selectors3.getUserId], (_selectedFeed, feedEntities, userEntities, anchors, _anchors, _currentUser) => {
  var feed = feedEntities[_selectedFeed];
  if (!feed) return {};
  var _target = _anchors.find(_anchor => anchors[_anchor]._feed === _selectedFeed);
  var anchor = anchors[_target];
  var target = anchor && userEntities[anchor._target];
  if (target) {
    return _objectSpread(_objectSpread({}, feed), {}, {
      user: target,
      isOwned: target.id === _currentUser
    });
  }
  if (feed._user && userEntities[feed._user]) {
    return _objectSpread(_objectSpread({}, feed), {}, {
      user: userEntities[feed._user],
      isOwned: feed._user === _currentUser
    });
  }
  if (_target) {
    return _objectSpread(_objectSpread({}, feed), {}, {
      user: userEntities[_target],
      isOwned: feed._user === _target
    });
  }
  return feed;
});
var getTypingUsers = exports.getTypingUsers = (0, _reselect.createSelector)([_getFeedParameter, feedTypingSelector, _selectors5.userEntitiesSelector, _selectors.currentRoomSelector], (_feed, typingFeeds, userEntities, room) => {
  var _typingFeeds$_feed;
  if ((typingFeeds === null || typingFeeds === void 0 || (_typingFeeds$_feed = typingFeeds[_feed]) === null || _typingFeeds$_feed === void 0 ? void 0 : _typingFeeds$_feed.expiredAt) > Date.now()) {
    var _payload$_users;
    var payload = typingFeeds[_feed];
    return (_payload$_users = payload._users) === null || _payload$_users === void 0 || (_payload$_users = _payload$_users.map(_user => userEntities[_user] || (room === null || room === void 0 ? void 0 : room.members.find(m => m._user === _user)))) === null || _payload$_users === void 0 ? void 0 : _payload$_users.filter(user => !!(user !== null && user !== void 0 && user.id));
  }
  return null;
});
var getSubscriptionFeeds = state => state.feeds.subscriptions || {};
exports.getSubscriptionFeeds = getSubscriptionFeeds;